import React, { useState } from "react";
import { Sparkles, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Paragraphs } from "./Rich";

export const ExplainSimpler = ({ chapterId, blockId }) => {
  const { user } = useAuth();
  const [state, setState] = useState({ loading: false, paragraphs: null });

  const run = async () => {
    if (!user) return toast.error("Log in to get a simpler explanation");
    setState({ loading: true, paragraphs: null });
    try {
      const r = await api.post(`/notes/${chapterId}/explain`, { block_id: blockId });
      setState({ loading: false, paragraphs: r.data.paragraphs });
    } catch (e) {
      setState({ loading: false, paragraphs: null });
      toast.error(e.response?.data?.detail || "Couldn't explain right now");
    }
  };

  if (state.paragraphs) {
    return (
      <div className="mt-4 rounded-lg border border-yellow-300/30 bg-yellow-300/[0.06] p-4 fade-up" data-testid={`explain-result-${blockId}`}>
        <div className="flex items-center justify-between mb-2">
          <span className="text-[11px] uppercase tracking-[0.18em] text-yellow-300 font-semibold inline-flex items-center gap-1.5">
            <Sparkles className="w-3.5 h-3.5" /> In simpler words
          </span>
          <button onClick={() => setState({ loading: false, paragraphs: null })} className="text-zinc-400 hover:text-zinc-100" data-testid={`explain-close-${blockId}`}>
            <X className="w-4 h-4" />
          </button>
        </div>
        <Paragraphs items={state.paragraphs} className="text-sm text-zinc-200" />
      </div>
    );
  }

  return (
    <button
      onClick={run}
      disabled={state.loading}
      className="mt-3 inline-flex items-center gap-1.5 text-xs text-yellow-300/90 hover:text-yellow-200 transition-colors disabled:opacity-60"
      data-testid={`explain-btn-${blockId}`}
    >
      {state.loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Sparkles className="w-3.5 h-3.5" />}
      {state.loading ? "Simplifying…" : "Explain this simpler"}
    </button>
  );
};
